import { render, staticRenderFns } from "./simple-button.vue?vue&type=template&id=4e1870c1"
import script from "./simple-button.vue?vue&type=script&lang=js"
export * from "./simple-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports